import { useCallback, useMemo } from 'react';

import {
  MediaContainerProps,
  MediaDisplay,
  MediasProps,
} from '@/components/LegacyMediaContainer/types';
import stopPropagation from '@/consts/stopPropogation';
import { MediaKindEnum } from '@/types/schema';

import EditAction from '../EditAction';

export enum MediaActions {
  REMOVE,
}

export const editAction = [
  {
    id: MediaActions.REMOVE,
    renderer: EditAction,
  },
];

function useMediaList(
  medias?: MediaContainerProps['medias'],
  actions?: MediaContainerProps['mediaActions'],
  onMediaAction?: MediaContainerProps['onMediaAction'],
) {
  const defaultDisplay = useMemo(() => {
    const isMixedContent = medias?.find(
      (media) => media.kind !== MediaKindEnum.Image && media.kind !== MediaKindEnum.Video,
    );

    return isMixedContent ? MediaDisplay.LIST : MediaDisplay.GRID;
  }, [medias]);

  const onAction = useCallback<NonNullable<MediasProps['onAction']>>(
    (actionId, media, event) => {
      onMediaAction?.(actionId, media);
      switch (actionId) {
        case MediaActions.REMOVE: {
          stopPropagation(event);
        }
      }
    },
    [onMediaAction],
  );

  return {
    defaultDisplay,
    actions,
    onAction,
  };
}

export default useMediaList;
